<mat-form-field class="w-full">
    <mat-label>
        @if (labelIsString()) {
            {{ labelText() | translate }}
        } @else {
            <apcam-translation [model]="labelTranslationModel()" />
        }
    </mat-label>
    <button
        matPrefix
        type="button"
        mat-button
        class="ms-2 inline-flex gap-1 h-8 items-center"
        [matMenuTriggerFor]="countryMenu"
        [disabled]="disabled()"
        [attr.aria-label]="'shared.phoneInput.countryAriaLabel' | translate">
        <mat-icon class="!m-0 !h-5 !w-5 !text-[1.25rem] !leading-5"
            >arrow_drop_down</mat-icon
        >
        @if (selectedCountryIso2Option(); as option) {
            <div class="flex items-center gap-2">
                <apcam-flag
                    [flagCode]="option.iso2"
                    [altText]="option.name"
                    [width]="20" />
                <span class="text-gray-500 font-medium">
                    +{{ option.dialCode }}
                </span>
            </div>
        } @else {
            <mat-icon class="me-0!">public</mat-icon>
        }
    </button>
    <mat-menu #countryMenu="matMenu" class="max-h-[min(60svh,20rem)]">
        @for (option of countryOptions(); track option.iso2) {
            <button
                mat-menu-item
                type="button"
                (click)="handleCountrySelect(option.iso2)">
                <div class="flex items-center gap-2">
                    <apcam-flag
                        [flagCode]="option.iso2"
                        [altText]="option.name"
                        [width]="20" />
                    <span>{{ option.name }}</span>
                    <span class="text-gray-500">+{{ option.dialCode }}</span>
                </div>
            </button>
        }
    </mat-menu>
    <input
        #nationalInput
        matInput
        type="tel"
        autocomplete="tel-national"
        inputmode="tel"
        [errorStateMatcher]="parentErrorStateMatcher"
        [required]="required()"
        [formControl]="nationalControl"
        [placeholder]="placeholder()"
        (blur)="handleBlur()"
        (input)="handleNationalInput(nationalInput.value)" />
    @if (
        !disabled() && (nationalControl.value || selectedCountryIso2Option())
    ) {
        <button
            matSuffix
            mat-icon-button
            type="button"
            [disabled]="disabled()"
            [attr.aria-label]="'shared.buttons.clear' | translate"
            (click)="handleClear()">
            <mat-icon>cancel</mat-icon>
        </button>
    }
    @if (errorMessageKey(); as errorKey) {
        <mat-error>
            {{ errorKey | translate }}
        </mat-error>
    }
</mat-form-field>
